/* eslint-disable prefer-promise-reject-errors */
import config from 'src/config';
import { postRequest, putRequest } from 'src/utils/RequestUtil';

export const areaSearchAPI = function (data) {
    const url = `${config.baseUrl}area/search`;
    return postRequest({
        url,
        data,
    });
};

export const areaCreateAPI = function (data) {
    const url = `${config.baseUrl}area`;
    return postRequest({
        url,
        data,
    });
};

export const areaUpdateAPI = function ({
    areaId,
    data,
}) {
    const url = `${config.baseUrl}area/${areaId}`;
    return putRequest({
        url,
        data,
    });
};
